import { GridCellProps } from '@progress/kendo-react-grid';
import GoToPoDetailsById from 'src/components/GoToPoDetailsById';
import GridCellBase, { useGridCellDisplayValue } from 'src/components/GridCellBase';

const GoToPoJournal = (props: GridCellProps) => {
  const { dataItem } = props;
  const actionType = dataItem.action.includes('Journal');
  const { value } = useGridCellDisplayValue(props);

  return (
    <>
      {actionType ? (
        <GridCellBase {...props} title={value}>
          <span>{value}</span>
        </GridCellBase>
      ) : (
        <GoToPoDetailsById {...props} />
      )}
    </>
  );
};
export default GoToPoJournal;
